import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Gift = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M11 22v-9H4v7a2 2 0 0 0 2 2h5zm9-2v-7h-7v9h5a2 2 0 0 0 2-2zM19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H2v4h9V9h2v2h9V7h-3.209A4.92 4.92 0 0 0 19 5.5zm-12 0C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM15.5 4c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.477c.51-1.576 1.251-3 1.977-3z", key: "k0" })));
});
Gift.displayName = 'Gift';
export var GiftDimensions = { height: 24, width: 24 };
